<template>
    <ImageLabel class="th w-100">
        <img class="ph2" src="@/assets/img/icon_forms_money.svg"/>
        <vue-numeric separator="," :precision="2" :value="value" @input="$emit('input', $event)" class="flex-auto input-reset bn outline-0"></vue-numeric>
    </ImageLabel>
    
</template>

<script>
import ImageLabel from '@/components/controls/ImageLabel.vue';
import VueNumeric from 'vue-numeric';

export default {
    props: {
        value: {
            type: Number
        }
    },
    components: {
        VueNumeric,
        ImageLabel
    }
};
</script>
